import DeviceContract from "@/models/server/DeviceContract";

export default class ServiceDeviceContract
{
    public deviceContract: DeviceContract = new DeviceContract();

    public deviceContractsFrom: Date | null = null;

    public deviceContractsTo: Date | null = null;

    public isServiceDeviceContract: boolean = true;
}